import React from "react";
import {connect} from "react-redux";
import {bindActionCreators, Dispatch} from "redux";
import {Helpers} from "../../../core/utilities/helpers";
import {IStore} from "../../../core/utilities/reducers";
import {router} from "../../../core/utilities/router";
import AppHeader from "../../AppHeader/AppHeader";
import MiscHeader from "../../MiscHeader/MiscHeader";
import "./AppLayout.scss";

interface IProps {
  children: any;
  pathname: string;
}

class AppLayout extends React.Component<IProps> {
  
  private isNavigationHeaderVisible(): boolean {
    return (
      !Helpers.isRouteMisc(this.props.pathname) &&
      !Helpers.isRoutePayByMeResult(this.props.pathname)
    );
  }
  
  private isAppHeaderVisible(): boolean {
    return (
      this.isNavigationHeaderVisible() &&
      this.props.pathname !== router.LEADERBOARD &&
      this.props.pathname !== router.INVALID_TOKEN
    );
  }
  
  private isMiscHeaderVisible(): boolean {
    return Helpers.isRouteMisc(this.props.pathname);
  }
  
  render() {
    return (
      <div id="app-layout">
        {
          this.isAppHeaderVisible() &&
          <AppHeader pathname={this.props.pathname}/>
        }
        {
          this.isMiscHeaderVisible() &&
          <MiscHeader/>
        }
        {this.props.children}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {},
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    pathname: store.setPathname.pathname,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(AppLayout);
